import { WORKSPACE_IDS } from '@/configs/workspace-ids';

export const KYOBO_WORKSPACE_ALIAS = WORKSPACE_IDS.KYOBO;
